var _rect, _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFormulary = function SvgFormulary(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.041 146H12L35.0612 26H152L129.041 146Z",
    fill: "#E6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129.5H15L14 135.5H131L132 129.5Z",
    fill: "#9FA4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 128.5C8 127.672 8.67157 127 9.5 127H136.5C137.328 127 138 127.672 138 128.5C138 129.328 137.328 130 136.5 130H9.5C8.67157 130 8 129.328 8 128.5Z",
    fill: "#313E48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 30.8H90.2002V67.2H123V30.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7002 29.3H124.5V68.7H88.7002V29.3ZM91.7002 32.3V65.7H121.5V32.3H91.7002Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3 14.5H84.7998V30.2H128.3V14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2998 13H129.8V31.7H83.2998V13ZM86.2998 16V28.7H126.8V16H86.2998Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 30.2V15.3H101V30.2H98Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.8 30.2V15.3H115.8V30.2H112.8Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.401 54.4C104.201 54.4 102.401 53.1 101.401 52L100.601 51.1L103.901 46.5L104.001 46.6V44.5L100.701 40.5L101.801 39.5C103.501 38.1 105.201 37.4 107.201 37.4C111.101 37.4 113.601 39.5 113.601 42.7C113.601 43.8 113.201 44.7 112.601 45.5C113.501 46.4 114.001 47.6 114.001 48.9C114.201 52.2 111.401 54.4 107.401 54.4Z",
    fill: "#9FA4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 38.9C110.3 38.9 112.2 40.3 112.2 42.7C112.2 44 111.5 45 110 45.6V45.7C111.5 46.2 112.6 47.2 112.6 48.9C112.6 51.5 110.2 52.9 107.4 52.9C105.2 52.9 103.6 52.2 102.6 51L104.3 48.7C105.1 49.5 106.1 50 107.1 50C108.3 50 109.1 49.6 109.1 48.7C109.1 47.7 108.6 47.1 105.7 47.1V44.5C108 44.5 108.6 43.9 108.6 43C108.6 42.2 108.1 41.8 107.2 41.8C106.3 41.8 105.7 42.2 104.8 42.9L103 40.7C104.3 39.5 105.7 38.9 107.3 38.9ZM107.3 35.9C105 35.9 102.9 36.7 101 38.4L98.7002 40.3L100.6 42.6L102.4 44.8L102.6 45V45.9L101.8 47L100.1 49.3L98.7002 51.2L100.2 53C101.4 54.4 103.5 56 107.3 56C112.1 56 115.5 53.1 115.5 49C115.5 47.7 115.1 46.4 114.4 45.4C114.8 44.6 115 43.7 115 42.7C115.2 38.6 112.1 35.9 107.3 35.9Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 128.1V99.8C21.5 98.1431 22.8431 96.8 24.5 96.8H63V67.8H124.6C126.257 67.8 127.6 69.1431 127.6 70.8V128.1H21.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 66.3H124.6C127.085 66.3 129.1 68.3147 129.1 70.8V129.6H20V99.8C20 97.3147 22.0147 95.3 24.5 95.3H61.5V66.3ZM64.5 69.3V98.3H24.5C23.6716 98.3 23 98.9716 23 99.8V126.6H126.1V70.8C126.1 69.9716 125.428 69.3 124.6 69.3H64.5Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0002 59.8H61.2002V96.2H94.0002V59.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7002 58.3H95.5002V97.7H59.7002V58.3ZM62.7002 61.3V94.7H92.5002V61.3H62.7002Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2998 43.5H55.7998V59.2H99.2998V43.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2998 42H100.8V60.7H54.2998V42ZM57.2998 45V57.7H97.7998V45H57.2998Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 59.2V44.3H72V59.2H69Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7998 59.2V44.3H86.7998V59.2H83.7998Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2 100.8L113.6 105.7L119 106.5L115.1 110.3L116 115.7L111.2 113.2L106.4 115.7L107.3 110.3L103.4 106.5L108.8 105.7L111.2 100.8Z",
    fill: "#EADB9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.2 99.3C111.773 99.3 112.296 99.626 112.548 100.14L114.601 104.332L119.22 105.016C119.784 105.1 120.252 105.496 120.428 106.039C120.603 106.581 120.456 107.176 120.047 107.574L116.709 110.827L117.48 115.453C117.574 116.014 117.342 116.58 116.882 116.914C116.421 117.248 115.812 117.293 115.308 117.03L111.2 114.891L107.093 117.03C106.589 117.293 105.979 117.248 105.519 116.914C105.059 116.58 104.827 116.014 104.921 115.453L105.692 110.827L102.354 107.574C101.945 107.176 101.798 106.581 101.973 106.039C102.149 105.496 102.617 105.1 103.181 105.016L107.8 104.332L109.853 100.14C110.105 99.626 110.628 99.3 111.2 99.3ZM111.2 104.21L110.148 106.36C109.93 106.803 109.509 107.111 109.02 107.184L106.617 107.54L108.347 109.226C108.699 109.569 108.861 110.062 108.78 110.547L108.374 112.981L110.508 111.87C110.942 111.643 111.459 111.643 111.893 111.87L114.027 112.981L113.621 110.547C113.54 110.062 113.702 109.569 114.054 109.226L115.784 107.54L113.381 107.184C112.892 107.111 112.471 106.803 112.253 106.36L111.2 104.21Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7996 108.6H76.5996V114.9H96.7996V108.6Z",
    fill: "#CFD9E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0996 108.6C75.0996 107.772 75.7712 107.1 76.5996 107.1H96.7996C97.628 107.1 98.2996 107.772 98.2996 108.6V114.9C98.2996 115.728 97.628 116.4 96.7996 116.4H76.5996C75.7712 116.4 75.0996 115.728 75.0996 114.9V108.6ZM78.0996 110.1V113.4H95.2996V110.1H78.0996Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3 84.3V80L71.9 79.5C74.6 77 77.4 74.5 77.4 73.2C77.4 72.9 77.3 72.8 77.3 72.8C77.3 72.8 77.2 72.8 77.1 72.8C76.8 72.8 76.3 73.2 75.8 73.7L74.7 74.8L70.5 70.6L71.5 69.5C73.4 67.5 75.1 66.7 77.6 66.7C81.4 66.7 84 69.3 84 72.9C84 74.7 83.1 76.4 81.9 78.1H84.7V84.4H71.3V84.3Z",
    fill: "#94C1AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6004 68.2C80.5004 68.2 82.5004 70.1 82.5004 72.9C82.5004 75.2 80.3004 77.8 78.4004 79.8C79.1004 79.7 80.2004 79.6 80.8004 79.6H83.2004V82.9H72.8004V80.7C76.2004 77.6 78.8004 75.2 78.8004 73.2C78.8004 71.9 78.1004 71.3 77.0004 71.3C76.0004 71.3 75.3004 72 74.6004 72.7L72.5004 70.6C74.1004 68.9 75.5004 68.2 77.6004 68.2ZM77.6004 65.2C74.7004 65.2 72.6004 66.2 70.4004 68.5L68.4004 70.6L70.5004 72.7L72.6004 74.8L73.6004 75.8C72.7004 76.7 71.7004 77.6 70.8004 78.4L70.7004 78.5L69.7004 79.4V80.7V82.9V85.9H72.7004H83.1004H86.1004V82.9V79.6V76.6H84.5004C85.1004 75.4 85.4004 74.2 85.4004 72.9C85.5004 68.4 82.2004 65.2 77.6004 65.2Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0002 128H32.2002L32.4002 89.6226H65.2002L65.0002 128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.908 88.1226H66.7081L66.4924 129.5H30.6924L30.908 88.1226ZM33.8924 91.1226L33.7081 126.5H63.508L63.6924 91.1226H33.8924Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 73.5H27V89.029H70.5V73.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 72H72V90.529H25.5V72ZM28.5 75V87.529H69V75H28.5Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2998 89.0291V74.2914H43.2998V89.0291H40.2998Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0996 89.0291V74.2914H58.0996V89.0291H55.0996Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4004 117.1V110.7H45.8004V105.6H42.8004V100.2L44.0004 100C45.5004 99.7 46.5004 99.3 47.6004 98.7L48.0004 98.5H53.0004V110.7H55.8004V117.1H42.4004Z",
    fill: "#F9AF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5004 100V112.2H54.3004V115.6H43.9004V112.2H47.3004V104.1H44.3004V101.5C46.1004 101.2 47.2004 100.7 48.4004 100H51.5004ZM54.5004 97H51.5004H48.4004H47.5004L46.8004 97.5C46.0004 98 45.3004 98.3 43.7004 98.6L41.3004 99V101.5V104.1V107.1H44.3004V109.2H43.9004H40.9004V112.2V115.6V118.6H43.9004H54.3004H57.3004V115.6V112.2V109.2H54.5004V100V97Z",
    fill: "#313E48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.8,
    height: 117.5,
    fill: "white",
    transform: "translate(20 13)"
  })))));
};
export { SvgFormulary as ReactComponent };
export default __webpack_public_path__ + "static/media/formulary.569aad7d.svg";